var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0052FF",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.04 15.25a6.31 6.31 0 1 0-6.3-6.83h8.35v1.06H2.75a6.31 6.31 0 0 0 6.29 5.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBase);
export default __webpack_public_path__ + "static/media/logoBase.230956be4293de7408a97c3de46a5981.svg";
export { ForwardRef as ReactComponent };